import styled, { css } from 'styled-components';

import { StyledTextFieldWrapper } from '../../BlueTheme';

export const TextFieldWrapper = styled(StyledTextFieldWrapper)(
  ({ theme: { admanColors } }) => css`
    position: relative;

    .TrekTextField-formControl {
      padding-left: 27px;
    }

    &::before {
      position: absolute;
      z-index: 1;
      content: '+1';
      font-family: InspireTWDC;
      font-size: 14px;
      color: ${admanColors!.gray.dark.fg[7]};
      top: 34px;
      left: 10px;
    }
  `
);
